<template>
  <!-- MODAL EDIT -->
  <b-modal
    id="modalEdit"
    title="แก้ไขตำแหน่งอุปกรณ์"
    size="xl"
    @ok="submitEdit"
  >
    <b-row>
      <b-col
        md="12"
        lg="6"
      >
        <b-row>
          <b-col
            md="12"
            lg="6"
          >
            <b-form-group
              label="รหัสอุปกรณ์"
              label-for="basicInput"
            >
              <b-form-input
                id="basicInput"
                v-model="editData.devid"
                placeholder="รหัสอุปกรณ์"
                readonly
              />
            </b-form-group>
          </b-col>
          <b-col
            md="12"
            lg="6"
          >
            <b-form-group
              label="STA"
              label-for="basicInput"
            >
              <b-form-input
                id="basicInput"
                v-model="editData.sta"
                placeholder="STA"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="12"
            lg="6"
          >
            <b-form-group
              label="ละติจูด"
              label-for="basicInput"
            >
              <b-form-input
                id="basicInput"
                v-model="editData.latitude"
                placeholder="ละติจูด"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="12"
            lg="6"
          >
            <b-form-group
              label="ลองจิจูด"
              label-for="basicInput"
            >
              <b-form-input
                id="basicInput"
                v-model="editData.longitude"
                placeholder="ลองจิจูด"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <!-- basic -->
      </b-col>

      <b-col
        lg="6"
        md="12"
      >
        <div class="map">
          <l-map
            ref="mymap"
            :zoom="zoom"
            :center="center"
            :options="{scrollWheelZoom:false, zoomControl: true, attributionControl:false}"
            @click="addMarker"
          >
            <l-tile-layer :url="url" />
            <l-marker
              v-for="(marker, index) in markers"
              :key="index"
              :lat-lng="marker"
            />
            <l-marker
              v-for="(marker, index) in markerss"
              :key="'marker'+index"
              :ref="'marker'+index"
              :lat-lng="[marker.latitude, marker.longitude]"
              :options="{ autoClose: false, closeOnClick: false }"
            >
              <l-icon
                :icon-size="[28, 40]"
                :icon-anchor="[16, 37]"
                :icon-url="require('@/assets/images/icons/Markerlighting.svg')"
              />
              <l-popup
                ref="popup"
              >
                <div>
                  <span style="color:white; padding: 1px; text-align: left; font-size:14px;">
                    ต้นที่: {{ marker.pole }}
                  </span><br>
                  <span style="color:white; padding: 1px; text-align: left; font-size:14px;">
                    รหัสอุปกรณ์: {{ marker.devid }}
                  </span>
                </div>
              </l-popup>
            </l-marker>
          </l-map>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import axios from '@axios'
import {
  BRow, BCol, BFormInput, BFormGroup,
} from 'bootstrap-vue'
/* eslint-disable global-require */
import {
  LMap, LMarker, LPopup, LTileLayer, LIcon,
} from 'vue2-leaflet'
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */
export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    LMap,
    LMarker,
    LPopup,
    LTileLayer,
    LIcon,
  },
  data() {
    return {
      editData: {
        devid: '',
        latitude: '',
        longitude: '',
        sta: '',
      },
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '',
      zoom: 15,
      center: [0, 0],
      markerss: [],
      markers: [],
    }
  },
  mounted() {
    this.getMarkerSEM()
  },
  methods: {
    editModal(did) {
      setTimeout(() => {
        this.$refs.mymap.mapObject.invalidateSize()
      }, 100)
      axios
        .post('/fetchLocationSEM', { devid: did })
        .then(response => {
          this.editData.devid = response.data.devid
          this.editData.latitude = response.data.latitude
          this.editData.longitude = response.data.longitude
          this.editData.sta = response.data.sta
        })
        .catch(error => {
          console.log(error)
        })
    },
    getMarkerSEM() {
      axios
        .post('/getMarkerSEM', { wid: this.$route.query.wid })
        .then(response => {
          this.center.splice(0)
          this.center.push(response.data[0].latitude)
          this.center.push(response.data[0].longitude)
          this.markerss = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    async submitEdit() {
      try {
        await axios.post('/updateLocationSEM', this.editData)
        console.log(this.editData)
        this.$swal({
          icon: 'success',
          title: '<span style="color:#000000">บันทึกสำเร็จ</span>',
          showConfirmButton: false,
          timer: 1500,
        })
        this.$emit('fetch')
      } catch (error) {
        console.log(error)
      }
    },
    addMarker(evt) {
      if (this.markers.length > 0) {
        this.markers = []
      }
      this.markers.push(evt.latlng)
      this.editData.latitude = evt.latlng.lat
      this.editData.longitude = evt.latlng.lng
    },
  },
}
</script>

<style lang="scss" scoped>
.map{
  width: 100%;
  height: 600px;
}
.vue2leaflet-map {
    &.leaflet-container{
    position: absolute;
    width: 100% - 1;
    height: 568px;
    }
}

</style>
